module.exports = __webpack_public_path__ + "static/img/5.76a5ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/5.png
// module id = W4Ck
// module chunks = 5